import SecureStorage from 'secure-web-storage';
const CryptoJS = require('crypto-js');

const STORAGE_SECRET = process.env.SECURE_STORAGE_KEY;
const hasStorageSecret = Boolean(STORAGE_SECRET);

if (!hasStorageSecret && typeof window !== 'undefined') {
  console.warn('SECURE_STORAGE_KEY is not configured. secureStorage will use plain text storage.');
}

const _storage = typeof window !== 'undefined' ? localStorage : {};
export const secureStorage = new SecureStorage(_storage, {
  hash(key) {
    key = hasStorageSecret ? CryptoJS.SHA256(key, STORAGE_SECRET) : CryptoJS.SHA256(key);

    return key.toString();
  },
  encrypt(data) {
    if (!hasStorageSecret) {
      return data;
    }

    data = CryptoJS.AES.encrypt(data, STORAGE_SECRET);

    data = data.toString();

    return data;
  },
  decrypt(data) {
    if (!hasStorageSecret) {
      return data;
    }

    data = CryptoJS.AES.decrypt(data, STORAGE_SECRET);

    data = data.toString(CryptoJS.enc.Utf8);

    if (!data) {
      return '';
    }

    return data;
  },
});
